import {combineReducers} from 'redux';

import filtersAndColumnsReducer, {type FiltersAndColumnsState} from './filters-and-columns/reducer';
import resultsReducer, {type ResultsState} from './results/reducer';

export interface NewListState {
    filtersAndColumns: FiltersAndColumnsState;
    results: ResultsState;
}

export default combineReducers<NewListState>({
    filtersAndColumns: filtersAndColumnsReducer,
    results: resultsReducer,
});
